/* ATHLO+ — Scroll typography pass: expressive-but-clean reveals (ADDON, removable)
 * ==========================================================================
 * Apple-grade entrance motion for the sections you scroll past: big headings
 * split into words that rise out of a clipped line (power4, 45ms stagger)
 * while the heading sharpens from a soft blur; the heading's following
 * siblings (intro copy, buttons) follow with a quiet fade-rise. Triggered
 * once per element at 85% viewport via ScrollTrigger (already Lenis-synced
 * by hub-app.js).
 *
 * Deliberately conservative about what it touches:
 *   - only <h1>/<h2> inside <main>, with plain text / <br> content only
 *     (headings containing links, spans, or Liquid-injected markup are left
 *     alone rather than risk breaking them)
 *   - skips anything already animated: [data-reveal] elements, the hero
 *     (has its own GSAP intro), the letterwall, the Locker, and the
 *     Shopify theme editor
 *   - nothing is hidden until GSAP + ScrollTrigger are confirmed present,
 *     so a missing library or any error = the page renders untouched
 *   - reduced-motion = inert
 * Removable: delete this file + its <script> line in theme.liquid.
 * ========================================================================= */
(function () {
  'use strict';

  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function css() {
    if (document.getElementById('hub-scrollfx-css')) return;
    var st = document.createElement('style');
    st.id = 'hub-scrollfx-css';
    st.textContent =
      '.sfx-line{display:inline-block;overflow:hidden;vertical-align:bottom;padding-bottom:.08em;margin-bottom:-.08em}' +
      '.sfx-line>span{display:inline-block;will-change:transform}';
    document.head.appendChild(st);
  }

  // Wrap each word of a plain-text (+<br>) heading in a clip-line span.
  // Returns the inner word spans, or null if the heading is too complex.
  function splitWords(el) {
    var nodes = Array.prototype.slice.call(el.childNodes);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      // markup inside → leave it alone. A .brand-case span (snippets/hub-brand-case.liquid) is
      // plain text with its own casing, so it is split like text and the casing is carried over.
      if (n.nodeType === 1 && n.tagName !== 'BR' && !(n.classList && n.classList.contains('brand-case'))) return null;
    }
    var frag = document.createDocumentFragment();
    nodes.forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'BR') { frag.appendChild(n); return; }     // keep <br>
      var keepCase = n.nodeType === 1;   // a .brand-case span: its words keep their own casing
      String(n.textContent).split(/(\s+)/).forEach(function (piece) {
        if (!piece) return;
        if (/^\s+$/.test(piece)) { frag.appendChild(document.createTextNode(' ')); return; }
        var line = document.createElement('span');
        line.className = 'sfx-line';
        var w = document.createElement('span');
        if (keepCase) w.className = 'brand-case';
        w.textContent = piece;
        line.appendChild(w);
        frag.appendChild(line);
      });
    });
    el.textContent = '';
    el.appendChild(frag);
    return el.querySelectorAll('.sfx-line > span');
  }

  function arm() {
    try {
      if (!window.gsap || !window.ScrollTrigger) return;
      if (window.Shopify && window.Shopify.designMode) return;
      gsap.registerPlugin(ScrollTrigger);
      css();

      var heads = document.querySelectorAll('main h1, main h2');
      Array.prototype.forEach.call(heads, function (h) {
        if (h.__sfx) return;
        if (h.hasAttribute('data-reveal') || h.querySelector('[data-reveal]')) return;
        // dialog/.es: a heading inside a pop-up sheet (the event sign-up's quick sheet) never scrolls
        // past 85%, so its ScrollTrigger never fires and the whole form stayed invisible (2026-11-03).
        if (h.closest('.hero, .hub-lw, .lk, [data-reveal], .shopify-section-header, .shopify-section-footer, dialog, [role="dialog"], .es')) return;
        var r = h.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.6 && r.bottom > 0) return;  // above the fold: don't re-animate what's already read
        var words = splitWords(h);
        if (!words || !words.length || words.length > 24) return;
        h.__sfx = true;

        try {
          gsap.set(words, { yPercent: 110 });
          gsap.set(h, { filter: 'blur(6px)', opacity: 0.001 });
        } catch (err) {
          // never leave a heading hidden: restore and skip this one
          gsap.set(h, { clearProps: 'all' });
          gsap.set(words, { clearProps: 'all' });
          return;
        }

        // quiet follow-up for the heading's next siblings (copy, buttons)
        var sibs = [];
        var s = h.nextElementSibling;
        while (s && sibs.length < 3) {
          if (!s.hasAttribute('data-reveal') && !s.querySelector('[data-reveal]') &&
              /^(P|A|DIV|UL|SPAN)$/.test(s.tagName)) sibs.push(s);
          s = s.nextElementSibling;
        }
        if (sibs.length) gsap.set(sibs, { y: 26, opacity: 0 });

        ScrollTrigger.create({
          trigger: h, start: 'top 85%', once: true,
          onEnter: function () {
            gsap.to(h, { filter: 'blur(0px)', opacity: 1, duration: 0.7, ease: 'power2.out',
              onComplete: function () { gsap.set(h, { clearProps: 'filter' }); } });
            gsap.to(words, { yPercent: 0, duration: 0.9, ease: 'power4.out', stagger: 0.045 });
            if (sibs.length) gsap.to(sibs, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out', stagger: 0.09, delay: 0.18 });
          }
        });
      });
    } catch (e) { /* fail safe: nothing was hidden before this point per-element */ }
  }

  function init() {
    if (REDUCE) return;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
    else arm();
  }

  init();
})();
